import { IconButton, Tooltip, useDisclosure } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import { MessageSquare } from "../../../shared/icons";
import FeedbackModal from "./FeedbackModal";

// Botão flutuante presente em todas as telas autenticadas (renderizado no AppShell).
export default function FeedbackButton() {
  const modal = useDisclosure();
  const { pathname } = useLocation();

  return (
    <>
      <Tooltip label="Enviar feedback" placement="left" hasArrow>
        <IconButton
          aria-label="Enviar feedback"
          icon={<MessageSquare size={22} />}
          onClick={modal.onOpen}
          position="fixed"
          right={{ base: 4, md: 6 }}
          bottom={{ base: 4, md: 6 }}
          zIndex="sticky"
          w="52px"
          h="52px"
          borderRadius="full"
          boxShadow="lg"
        />
      </Tooltip>
      <FeedbackModal isOpen={modal.isOpen} onClose={modal.onClose} page={pathname} />
    </>
  );
}
